// src/models/CommentModel.ts
import { createComment } from '@/factories/commentFactory'
import { type Comment } from '@/types/Comment'
import { formatDistanceToNow } from 'date-fns'

export const CommentModel = {
  // Factory method
  create: createComment,

  // Normalization method

  // Validation method
  validate(comment: Comment): boolean {
    return !!comment.content && !!comment.createdBy
  },

  // Display methods
  formatDisplayName(comment: Comment): string {
    return comment.content
  },

  formatDate(date: Date): string {
    return formatDistanceToNow(date, { addSuffix: true })
  },

  // Helper methods
  isEdited(comment: Comment): boolean {
    console.log('comment isEdited()', comment)
    return comment.updatedAt.getTime() !== comment.createdAt.getTime()
  },

  truncateContent(comment: Comment, maxLength: number = 100): string {
    if (comment.content.length <= maxLength) return comment.content
    return `${comment.content.substring(0, maxLength)}...`
  },
}
